import React from 'react';
import { cn } from '../cn';
import { formatCashUsd } from './formatters';
export const PortalCashTransactionSummaryGrid = ({ summary, filteredCount, className, variant = 'default', }) => {
    var _a, _b;
    const s = summary !== null && summary !== void 0 ? summary : {
        totalTransactions: 0,
        totalExpected: 0,
        totalReceived: 0,
        paidFullCount: 0,
        pendingPartialCount: 0,
        totalGrossMargin: 0,
    };
    if (variant === 'counterDeposit') {
        return (React.createElement("div", { className: cn('grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3', className) },
            React.createElement("div", { className: "rounded-lg border border-border bg-card p-4" },
                React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Counter Cash In"),
                React.createElement("p", { className: "mt-1 text-2xl font-bold" }, formatCashUsd(s.totalReceived)),
                React.createElement("p", { className: "text-xs text-muted-foreground" },
                    s.totalTransactions,
                    " deposits")),
            React.createElement("div", { className: "rounded-lg border border-green-200 bg-green-50/50 p-4" },
                React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Gross margin"),
                React.createElement("p", { className: "mt-1 text-2xl font-bold" }, formatCashUsd((_a = s.totalGrossMargin) !== null && _a !== void 0 ? _a : 0)),
                React.createElement("p", { className: "text-xs text-muted-foreground" }, "Shop profit metadata")),
            React.createElement("div", { className: "rounded-lg border border-blue-200 bg-blue-50/50 p-4" },
                React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Paid in full"),
                React.createElement("p", { className: "mt-1 text-2xl font-bold" }, s.paidFullCount),
                filteredCount != null ? (React.createElement("p", { className: "text-xs text-muted-foreground" },
                    "Filtered: ",
                    filteredCount)) : null)));
    }
    if (variant === 'counterRedemption') {
        return (React.createElement("div", { className: cn('grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3', className) },
            React.createElement("div", { className: "rounded-lg border border-border bg-card p-4" },
                React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Counter Cash Out"),
                React.createElement("p", { className: "mt-1 text-2xl font-bold" }, formatCashUsd((_b = s.totalCashOut) !== null && _b !== void 0 ? _b : s.totalReceived)),
                React.createElement("p", { className: "text-xs text-muted-foreground" },
                    s.totalTransactions,
                    " redemptions")),
            React.createElement("div", { className: "rounded-lg border border-amber-200 bg-amber-50/50 p-4" },
                React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Credits redeemed"),
                React.createElement("p", { className: "mt-1 text-2xl font-bold" }, formatCashUsd(s.totalExpected)),
                React.createElement("p", { className: "text-xs text-muted-foreground" }, "Total credit amount")),
            React.createElement("div", { className: "rounded-lg border border-blue-200 bg-blue-50/50 p-4" },
                React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Paid in full"),
                React.createElement("p", { className: "mt-1 text-2xl font-bold" }, s.paidFullCount),
                filteredCount != null ? (React.createElement("p", { className: "text-xs text-muted-foreground" },
                    "Filtered: ",
                    filteredCount)) : null)));
    }
    return (React.createElement("div", { className: cn('grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4', className) },
        React.createElement("div", { className: "rounded-lg border border-border bg-card p-4" },
            React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Total transactions"),
            React.createElement("p", { className: "mt-1 text-2xl font-bold" }, s.totalTransactions),
            filteredCount != null ? (React.createElement("p", { className: "text-xs text-muted-foreground" },
                "Filtered: ",
                filteredCount)) : null),
        React.createElement("div", { className: "rounded-lg border border-blue-200 bg-blue-50/50 p-4" },
            React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Total expected"),
            React.createElement("p", { className: "mt-1 text-2xl font-bold" }, formatCashUsd(s.totalExpected)),
            React.createElement("p", { className: "text-xs text-muted-foreground" }, "Expected cash")),
        React.createElement("div", { className: "rounded-lg border border-green-200 bg-green-50/50 p-4" },
            React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Paid in full"),
            React.createElement("p", { className: "mt-1 text-2xl font-bold" }, formatCashUsd(s.totalReceived)),
            React.createElement("p", { className: "text-xs text-muted-foreground" },
                s.paidFullCount,
                " transactions")),
        React.createElement("div", { className: "rounded-lg border border-amber-200 bg-amber-50/50 p-4" },
            React.createElement("p", { className: "text-xs font-medium text-muted-foreground" }, "Pending / partial"),
            React.createElement("p", { className: "mt-1 text-2xl font-bold" }, "\u2014"),
            React.createElement("p", { className: "text-xs text-muted-foreground" },
                s.pendingPartialCount,
                " transactions"))));
};
